import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'membership-offer',
		path: '/member/offer',
		component: loadable(async () => import(/* webpackChunkName: "pages/membership-offer" */ './index'), {
			exportName: 'MembershipOffer',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: true,
		},
	},
	{
		id: 'membership-offer-psf',
		path: '/p/:slug/member/offer',
		component: loadable(async () => import(/* webpackChunkName: "pages/membership-offer" */ './index'), {
			exportName: 'MembershipOffer',
			fallback: Loading,
		}),
		frame: {
			header: false,
			footer: false,
		},
	},
];
